const menuToggle = document.querySelector('.menu-toggle');
const nav = document.getElementById('main-nav');
const navClose = document.querySelector('.mobile-nav-close');

function openMenu() {
  nav.classList.add('is-open');
  menuToggle.classList.add('is-active');
  menuToggle.setAttribute('aria-expanded', 'true');
  nav.setAttribute('aria-hidden', 'false');
  document.body.classList.add('no-scroll');
}

function closeMenu() {
  nav.classList.remove('is-open');
  menuToggle.classList.remove('is-active');
  menuToggle.setAttribute('aria-expanded', 'false');
  nav.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('no-scroll');
}

menuToggle.addEventListener('click', () => {
  nav.classList.contains('is-open') ? closeMenu() : openMenu();
});

navClose.addEventListener('click', closeMenu);

nav.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', closeMenu);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && nav.classList.contains('is-open')) {
    closeMenu();
  }
});
